import React, { Component, useState, useEffect } from 'react';
import Board from './Board';
import './Tictactoe.css';
import PythonApi from './PythonApi';
import { usePromiseTracker } from "react-promise-tracker";
import { trackPromise } from 'react-promise-tracker';
import Loader from 'react-loader-spinner'

const Tictactoe = () => {
  const [board, setBoard] = useState(null);
  const [xMove, setXMove] = useState(null);
  const [yMove, setYMove] = useState(null);
  const [playerTurn, setPlaterTurn] = useState(true);
  const [winner, setWinner] = useState(false);
  const [keepPlaying, setKeepPlaying] = useState(true);
  const [isSpinnerEnabled, setSpinnerEnable] = useState(true);

  useEffect(() => {
    if (board == null) {
      startGame();
    } else if (!playerTurn && !winner) {
      fetchNewBoard(board, xMove, yMove);
      setPlaterTurn(true);
    }
  }, [xMove, yMove, winner]);

  const updateBoard = (x, y) => {
    setXMove(x);
    setYMove(y);
    setPlaterTurn(false);
  };

  const LoadingIndicator = props => {
    const {promiseInProgress} = usePromiseTracker();

    return (
      promiseInProgress && isSpinnerEnabled &&
        <div className="ui centered">
          <Loader type="Rings" color="#00BFFF" height={80} width={80} />AI thinking...
        </div>
    )
  };

  const fetchNewBoard = async (board, xMove, yMove) => {
    if (isSpinnerEnabled) {
      trackPromise(
        PythonApi.post('/tictactoe', { 
          board: board,
          x: xMove,
          y: yMove
        }).then((response) => {
            setBoard(response.data.board);
            setWinner(response.data.winner);
            setSpinnerEnable(false);
            setKeepPlaying(response.data.keepPlaying)
          }
        )
      );
    } else {
      const response = await PythonApi.post('/tictactoe', { 
        board: board,
        x: xMove,
        y: yMove
      });

      setBoard(response.data.board);
      setWinner(response.data.winner);
      setSpinnerEnable(false);
      setKeepPlaying(response.data.keepPlaying);
    } 
  };

  const startGame = async () => {
    const response = await PythonApi.get('/tictactoe', {});
    setBoard(response.data.board);
    setXMove(null);
    setYMove(null);
    setPlaterTurn(true);
    setWinner(false);
    setSpinnerEnable(true);
    setKeepPlaying(true);
  };

  if (board != null) {
    return (
      <div>     
        <div className="center">
          <h2>The impossible to win Tic tac toe</h2>
          <LoadingIndicator />
          <Board board={board} updateBoard={updateBoard} winner={winner} keepPlaying={keepPlaying}/>
          <div>
          <br></br>
          <button className="ui primary button" onClick={startGame}> Start a new game! </button>
        </div>
      </div>
      </div>     
    )
  }

  return 'loading';
}

export default Tictactoe;